import Alpine from "../alpine.js"

Alpine.data("assessmentWizard", ({ step, stepCount, updateUrl, complete, incompleteSteps }) => ({
  step,
  stepCount,
  updateUrl,
  complete,
  incompleteSteps,
  events: {
    ["@assessment-screen-complete"]: "next",
    ["@assessment-screen-cancel"]: "prev",
    ["@assessment-value-updated"] (event) {
      if (event.detail.complete !== undefined) {
        this.complete = event.detail.complete
      }

      if (event.detail.incomplete_steps !== undefined) {
        this.incompleteSteps = event.detail.incomplete_steps
      }
    }
  },
  next () {
    if ((this.step) < this.stepCount) {
      this.step = this.step + 1
      this.$nextTick(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) })
    }
  },
  prev () {
    if (this.step > 1) {
      this.step = this.step - 1
      this.$nextTick(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) })
    } else {
      window.history.back()
    }
  }
}))
